const Dates = {
    convertEnToBr(dataString: string, delimitador?: string){
        if (dataString){
            if (delimitador){
                const newDt = dataString.split(delimitador);
                return newDt[0].split('-').reverse().join('/')

            }
            return  dataString.split('-').reverse().join('/')
        }
    },
    adjustHours(hours: string){
        if (hours){
            let hArray = hours.split(':');
            return hArray[0]+":"+hArray[1];
        }
    },
    difDay(dateInitial: any, datefinal: any){
        // @ts-ignore
        const diffInMs   = new Date(datefinal) - new Date(dateInitial)
        return diffInMs / (1000 * 60 * 60 * 24);
    },
    addDaysToDate(date: string, days: number){
        let res = new Date(date);
        res.setDate(res.getDate() + days);
        return res.toISOString().slice(0, 10);
    },
    convertDateWithHours(date: any) {
        if (!date) return null;

        let dt: Date;

        // Caso 1: ISO (com T e Z)
        if (date.includes("T")) {
            dt = new Date(date);
        }
        // Caso 2: formato Y-m-d H:i:s
        else {
            // Substitui espaço por "T" para o JS entender
            // e adiciona "Z" para interpretar como UTC, se necessário
            dt = new Date(date.replace(" ", "T"));
        }

        // Se não for válido, retorna null
        if (isNaN(dt.getTime())) {
            return null;
        }

        // Monta retorno no formato desejado
        return dt.toLocaleDateString("pt-BR") + " " + dt.toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });

        /*if (date) {
            date = date.split("T")

            return new Date(date[0].replace(/-/g, '/')).toLocaleDateString('pt-br') +" "+ this.adjustHours(date[1]);
        }*/
    },
    convertDateStringComplet(date: any){
        if (date) {
            date = date.split("T")
            const newHours = date[1].substring(0, 5)
            const newDate = date[0]+' '+newHours
            return new Date(newDate).toLocaleString(undefined, {
                year: 'numeric',
                month: 'long',
                day: '2-digit',

            }) // 'Wednesday, 14/06/2023'

        }
    },
};
export default Dates;
